import script from "./MemberLimitedTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberLimitedTime.vue?vue&type=script&setup=true&lang=ts"

import "./MemberLimitedTime.vue?vue&type=style&index=0&id=0238bc88&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0238bc88"]])

export default __exports__